import { Alert } from "@interstate/components/Alert";
import {
  ConversationTypeEnum,
  ReplyOption
} from "@coxauto-ui/cxm/communications/interfaces";
import { StyledContainerAlert } from "./styled";

export interface ComplianceOptedOutAlertProps {
  selectedReplyOption: ReplyOption | null;
  messageFailedToSend: boolean;
  messageSentResponseFailedMsg: string;
  conversationType: ConversationTypeEnum;
}

export function ComplianceOptedOutAlert({
  selectedReplyOption,
  messageFailedToSend,
  messageSentResponseFailedMsg,
  conversationType
}: ComplianceOptedOutAlertProps) {
  if (selectedReplyOption && !messageFailedToSend) {
    return null;
  }

  const getComplianceError = () => {
    return `Customer has opted out of receiving ${conversationType} messages.`;
  };

  return (
    <StyledContainerAlert>
      <Alert id="MessageReplyWarning" role="warning" type="caution">
        {messageFailedToSend && messageSentResponseFailedMsg}
        {!messageFailedToSend && getComplianceError()}
      </Alert>
    </StyledContainerAlert>
  );
}
